import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ConfigProvider } from 'antd';
import AuditIcon from './icons/AuditIcons';
import './styles.css';

const IMAGES = {
    hero: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC_4825-1024x684.jpg',
    assess: [
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/cow-vehicle-factory--1024x683.jpg', text: 'Техническое оснащение фермы' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/CattlePro___1-1-2-1024x683.png', text: 'Наличие и качество основных кормов' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC00805-1-1024x683.png', text: 'Питательность рационов и кормов посредством экспресс тестирования' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC_4864-1024x683.jpg', text: 'Условия содержания животных' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC_0185_1-1024x683.jpg', text: 'Качество доения и воспроизводства стада' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/photo1670857818-1-1-1024x683.png', text: 'Правильность выращивания молодняка' },
    ],
    params: [
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/christian-widell-vrT-1024x680.jpg', text: 'Специалисты оценивают комфорт животных, условия для отдыха, микроклимат и освещение' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC_4794-1024x683.jpg', text: 'Проводится оценка состояния и здоровья животных по системе "Сигналы животных"' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC_0192_1-1024x683.jpg', text: 'Оцениваются приемы доения и использования молочного оборудования.' },
        { src: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/ullash-borah-wVtL-fp-1024x683.jpg', text: 'Оценивается качество родовспоможения во время отела' },
    ],
};

const steps = [
    { title: 'Заявка', text: 'Вы оставляете заявку на получение услуги' },
    { title: 'Данные', text: 'Представляете первичную информацию о вашем хозяйстве' },
    { title: 'Встреча', text: 'В течение 7 дней с момента заявки специалисты выезжают в хозяйство' },
    { title: 'Проверка', text: 'На ферме специалисты проводят 1 день — в течение рабочего дня проводят контроль всех процессов на ферме, связанных с кормлением и содержанием, оценку питательности кормов и рационов, их переваримости и качества смешивания' },
    { title: 'Отчетность', text: 'Формируется отчет по первоочередным и стратегическим мерам, которые необходимо принять в хозяйстве, а также рекомендации по их применению' },
    { title: 'Будущая работа', text: 'Составляется план мероприятий на предприятии, которые помогут повысить рентабельность в короткий срок (в перспективе нескольких месяцев)' },
    { title: 'Финансовый план', text: 'Дается экономическая оценка всех мероприятий на предприятии' },
];

const forWhom = [
    'Вы нуждаетесь в независимой оперативной оценке возможностей хозяйства',
    'Вы заинтересованы в повышении рентабельности производства',
    'Вы ищете способы сокращения необоснованно высоких показателей расхода кормов',
    'Ваше предприятие испытывает дефицит в ремонтном молодняке высокого качества (с крепким иммунитетом и потенциалом продуктивности)',
];

const results = [
    'Повышение рентабельности производства',
    'Быстрое внесение изменений в технологию кормления и содержания животных',
    'Устойчивый рост экономических показателей производства',
    'Снижение расходов на лечение, диагностику заболеваний, связанных с жкт, отелами',
    'Сокращение расходов на выращивание ремонтного молодняка',
];

const AuditFarm = () => {
    const navigate = useNavigate();

    return (
        <ConfigProvider
            theme={{
                token: { colorPrimary: '#D00202' },
                components: { Button: { colorPrimaryHover: '#ff3333' } },
            }}
        >
            <div className="audit-page">
                <div className="audit-container">
                    <h1 className="audit-title">Аудит фермы</h1>

                    <section className="audit-hero">
                        <img src={IMAGES.hero} alt="Аудит фермы" className="audit-hero-img" />
                        <div className="audit-hero-text">
                            <p>Составление плана мероприятий по повышению рентабельности предприятия.</p>
                            <p>Предлагаем комплексный подход к решению ваших задач.</p>
                        </div>
                    </section>

                    <section className="audit-section">
                        <h2 className="audit-section-title-center">Что это за услуга?</h2>
                        <p>
                            Аудит — это выезд специалистов (ветеринарный врач и зоотехник) на предприятие. Они проводят мониторинг всех технологических процессов, связанных с кормлением, содержанием и воспроизводством поголовья.
                        </p>
                    </section>

                    <section className="audit-section">
                        <h2 className="audit-section-title-center">Что оценивают специалисты?</h2>
                        <div className="audit-assess-grid">
                            {IMAGES.assess.map((item, i) => (
                                <div className="audit-assess-card" key={i}>
                                    <img src={item.src} alt={item.text} />
                                    <p>{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="audit-section">
                        <h2 className="audit-section-title-center">Для кого это услуга?</h2>
                        <p>Аудит фермы для вас актуален, если:</p>
                        <ol className="audit-for-whom">
                            {forWhom.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ol>
                    </section>

                    <section className="audit-section">
                        <h2 className="audit-section-title-center">Как проводится аудит?</h2>
                        <div className="audit-steps">
                            {steps.map((step, i) => (
                                <div className="audit-step" key={i}>
                                    <AuditIcon index={i} alt={step.title} />
                                    <div className="audit-step-content">
                                        <div className="audit-step-number">{i + 1}. <strong>{step.title}</strong></div>
                                        <p>{step.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="audit-section">
                        <h2 className="audit-section-title-center">Какие параметры исследуют специалисты?</h2>
                        <div className="audit-params-grid">
                            {IMAGES.params.map((item, i) => (
                                <div className="audit-params-card" key={i}>
                                    <img src={item.src} alt={item.text} />
                                    <p>{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="audit-section">
                        <h2 className="audit-section-title-center">Какой результат вы получите?</h2>
                        <ol className="audit-results">
                            {results.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ol>
                    </section>

                    <div className="audit-order-btn">
                        <Button
                            type="primary"
                            size="large"
                            block
                            onClick={() => navigate('/product/283328')}
                        >
                            Заказать услугу
                        </Button>
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default AuditFarm;
